import lessRequire from '../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';

import { locale as promoLabelsLocale } from '../../../../enums/offer-promo-labels';

lessRequire('modules/shared/offer-promo-labels.less');

const propTypes = {
	intl: PropTypes.func,
	labels: PropTypes.array
};

const OfferPromoLabels = ({ intl, labels }) => {
	const list = !Array.isArray(labels) ? [] : labels.map((label) => promoLabelsLocale[intl.language][label]).sort();

	return (
		<div className="offer-promo-labels">
			{list.map((label) => (
				<span
					className="offer-promo-labels__item font-proxima-nova-bold"
					key={label}
				>
					{label}
				</span>
			))}
		</div>
	);
};

OfferPromoLabels.propTypes = propTypes;

export default OfferPromoLabels;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/offer-promo-labels.js